import styled from "styled-components";
import { Banner } from "@similarweb/ui-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const BannerWrapper = styled.div<{ isTopBanner: boolean }>`
    margin: ${({ isTopBanner }) => (isTopBanner ? "8px 0 24px" : "24px 0 0")};
`;

export const SubtitleWrapper = styled.div`
    ${setFontVariant("body2")};
`;

export const StyledBanner = styled(Banner)<{ isNewDesign: boolean }>`
    background-color: ${({ isNewDesign }) => (isNewDesign ? colorsPalettes.blue[100] : "")};
`;

export const StyledGIF = styled.img`
    height: 56px;
    width: 56px;
`;
